import { Component } from '@angular/core';

@Component({
  selector: 'app-governorate-icon',
  imports: [],
  templateUrl: './governorate-icon.html',
  styleUrl: './governorate-icon.scss',
})
export class GovernorateIcon {

}
